import { useCallback } from 'react';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import { LambdaListEditor } from 'config-editor';
import {
  LambdaDefaults,
  DEFAULT_ARCHITECTURE,
  DEFAULT_RUNTIME,
  DEFAULT_MEMORY,
  DEFAULT_TIMEOUT,
  DEFAULT_SNAPSTART_ENABLED,
} from 'config-editor-common';
import { useObjectField } from '../fieldState';

type Props = FieldExtensionComponentProps<LambdaDefaults>;

export const LambdaDefaultsEditor = (props: Props) => {
  const { schema, uiSchema } = props;
  const title = schema.title || uiSchema?.['ui:title'] || 'Lambda Defaults';
  const description =
    schema.description || uiSchema?.['ui:description'] || 'Configure default values for lambdas';

  // Authorizer lambdas default to snapstart on. There is no ui:option for it — the template only
  // signals the distinction through the field's own title/description.
  const isAuthorizer =
    schema.title?.toLowerCase().includes('authorizer') ||
    schema.description?.toLowerCase().includes('authorizer');

  const fallback = useCallback(
    (): LambdaDefaults => ({
      runtime: DEFAULT_RUNTIME,
      architecture: DEFAULT_ARCHITECTURE,
      lambda_source: '',
      memory_size: DEFAULT_MEMORY,
      timeout: DEFAULT_TIMEOUT,
      snapstart: isAuthorizer ? true : DEFAULT_SNAPSTART_ENABLED,
      env_vars: {},
    }),
    [isAuthorizer],
  );

  const { value, commit } = useObjectField(props, { fallback });

  return (
    <LambdaListEditor
      lambdas={{}}
      defaults={value}
      onDefaultsChange={commit}
      onChange={() => {}} // No-op since showLambdas={false}
      title={title}
      description={description}
      showPaper
      showLambdas={false}
    />
  );
};
